import React, { useState, useRef, useEffect } from 'react';
import './CustomMultiSelect.css';

const CustomMultiSelect = ({
  onChange,
  options,
  selectedValues = [],
  error,
  disabled = false,
  style,
  placeholder = "Select"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const tagsContainerRef = useRef(null);

  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleOptionClick = (value, e) => {
    e.stopPropagation();
    if (selectedValues.includes(value)) {
      onChange(selectedValues.filter(v => v !== value));
    } else {
      onChange([...selectedValues, value]);
    }
  };

  const handleSelectAll = (e) => {
    e.stopPropagation();
    if (selectedValues.length === options.length) {
      onChange([]);
    } else {
      onChange(options.map(option => option.value));
    }
  };

  const removeTag = (value, e) => {
    e.stopPropagation();
    onChange(selectedValues.filter(v => v !== value));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getOptionLabel = (value) => {
    return options.find(option => option.value === value)?.label || value;
  };

  const isAllSelected = selectedValues.length === options.length;

  return (
    <div className="multi-select-container" ref={dropdownRef} style={style}>
      <div
        className={`multi-select-header ${disabled ? 'multi-select-disabled' : ''}`}
        onClick={handleToggle}
      >
        <div className="multi-selected-tags" ref={tagsContainerRef}>
          {selectedValues.length > 0 ? (
            selectedValues.map(value => (
              <div key={value} className="multi-selected-tag">
                <span className="multi-tag-label">{getOptionLabel(value)}</span>
                <span
                  className="multi-tag-remove"
                  onClick={(e) => removeTag(value, e)}
                >
                  ×
                </span>
              </div>
            ))
          ) : (
            <span className="multi-placeholder">{placeholder}</span>
          )}
        </div>
        <div className={`multi-arrow ${isOpen ? 'multi-arrow-open' : ''}`}></div>
      </div>

      {isOpen && (
        <div className="multi-options-container">
          {/* Select All option */}
          <div
            className={`multi-option-item select-all-option ${isAllSelected ? 'multi-selected' : ''}`}
            onClick={(e) => handleSelectAll(e)}
          >
            <input
              type="checkbox"
              checked={isAllSelected}
              onChange={() => { }}
              className="multi-option-checkbox"
            />
            <span className="multi-option-label">Select All</span>
          </div>

          {options.map((option) => (
            <div
              key={option.value}
              className={`multi-option-item ${selectedValues.includes(option.value) ? 'multi-selected' : ''}`}
              onClick={(e) => handleOptionClick(option.value, e)}
            >
              <input
                type="checkbox"
                checked={selectedValues.includes(option.value)}
                onChange={() => { }}
                className="multi-option-checkbox"
              />
              <span className="multi-option-label">{option.label}</span>
            </div>
          ))}
        </div>
      )}
      {error && <div className='multi-error-message'>{error}</div>}
    </div>
  );
};

export default CustomMultiSelect;